export class AgreementStruct {
  idAgreement: number;
  agreementAccept: boolean;
}

export class UploadLivroRequest {
  idBook?: number;
  idBookVersion?: number;
  fileName: string;
  base64File: string;
  listAgreementStruct: AgreementStruct[];
}